import { useEffect, useState } from "react"
import { toast } from "sonner"
import api, { getApiError } from "@/lib/api"
import { useAuth } from "@/lib/auth-context"
import { useUnsavedChanges } from "@/lib/unsaved-changes-context"
import { clearSelectedBranch, saveBranchMeta, saveSelectedBranch } from "@/lib/branch-selection"

export function BranchSwitcher() {
  const { user } = useAuth()
  const { requestLeave } = useUnsavedChanges()
  const [branches, setBranches] = useState<{ id: number; name: string }[]>([])
  const [active, setActive] = useState("")
  useEffect(() => {
    if (!user?.isTenantAdmin || !user.features?.multiBranch) return
    let cancelled = false
    api.get("/api/branches").then(({ data }) => {
      if (!cancelled) {
        saveBranchMeta(data.mainBranchId, data.branches)
        setBranches(data.branches)
        setActive(String(data.activeBranchId))
      }
    }).catch((error) => {
      if (!cancelled) { clearSelectedBranch(); toast.error(getApiError(error, "Could not load branches")) }
    })
    return () => { cancelled = true }
  }, [user?.id, user?.isTenantAdmin, user?.features?.multiBranch])
  if (user?.features?.multiBranch && !user.isTenantAdmin) {
    return <p className="grid gap-1 px-2 pb-2 text-xs">
      Branch
      <span className="flex h-9 items-center rounded-md border bg-muted px-2 text-sm">{user.homeBranchName?.trim() || "Main Branch"}</span>
    </p>
  }
  if (!user?.isTenantAdmin || !user.features?.multiBranch || branches.length === 0) return null
  return <label className="grid gap-1 px-2 pb-2 text-xs">
    Branch
    <select aria-label="Active branch" className="h-9 w-full rounded-md border bg-background px-2 text-sm" value={active}
      onChange={(event) => {
        const id = Number(event.target.value)
        requestLeave(() => { saveSelectedBranch(id); window.location.assign("/dashboard") })
      }}>
      {branches.map((branch) => <option key={branch.id} value={branch.id}>{branch.name}</option>)}
    </select>
  </label>
}
